import { EntityModel } from "./EntityModel";

export class MdsModel {
    processingPurposeId: number;
    entities: EntityModel[];

    constructor() {
        this.entities = [];
    }
}